import type { FeedItem } from '@olimhub/shared'

// A translation's own id lives at data.post.id, not data.id — every other
// kind carries a flat id on data.
export function getFeedItemId(item: FeedItem): string {
  return item.kind === 'translation' ? item.data.post.id : item.data.id
}
